export default function Development() {
    return (
        <div className="container">
            <p>Diplom Wirtschafts-Informatiker (FH)</p>
            <p>Certified Scrum Master</p>
            <br />

            <h1>Agentic Engineering</h1>
            <p>Claude Code, Cursor AI, Github Copilot</p>
            <p>Context driven, Spec driven</p>
            <br />

            <h1>Java</h1>
            <p>Java (1.4 - 26), Java EE (1.4 - 10), Spring, Spring Boot</p>
            <p>Quarkus, Payara, Glassfish, Weblogic, Websphere, SAP NetWeaver, JBoss, Tomcat</p>
            <p>CDI, EJB 3, EJB Timer, JAX RS, JMS, JTA, JCA, CommonJ, JPA, Eclipse Link, Hibernate, Bean Validation, Managed Beans, Java Mail, Microprofile, Apache POI, Swagger, Flyway, Bouncy Castle, Lombok, Swing, RMI</p>
            <p>Maven, Gradle, Ant, JUnit, Mockito, PowerMock, AssertJ, Wiremock, Arquillian</p>
            <br />

            <h1>Python</h1>
            <p>Python 3, Python Unit Tests, FastAPI, SQLAlchemy, Alembic, Pydantic, Plotly</p>
            <p>uv, pip, venv, PyLint, ISort, MyPy, Vulture, Bandit, Flake8</p>
            <br />

            <h1>Web</h1>
            <p>Nginx, Apache HTTPD, HAProxy</p>
            <p>REST, HTML, CSS, JavaScript, Typescript, NPM, Webpack, Parcel</p>
            <p>React, Axios, Ant Design (AntD), Material UI, Jest, Zustand, Plotly</p>
            <p>Angular (JS - 11)</p>
            <p>JSF, Struts, JSP, Java Servlets</p>
            <p>WebGL, ThreeJS, React Three Fiber (R3F)</p>
            <br />

            <h1>Data Storage</h1>
            <p>SQL: MS SqlServer, PostgreSQL, MySQL, MariaDB, DB2, SAP Hana DB, Oracle DB</p>
            <p>NoSQL: Redis, MongoDB, DynamoDB, InfluxDB</p>
            <p>Minio, S3, Garage, NFS, SMB</p>
            <br />

            <h1>Infrastructure</h1>
            <p>Docker, Compose, Podman, Quadlets</p>
            <p>Kubernetes, K3S, Minikube, Terraform, Ansible, Helm, ArgoCD, GitOps</p>
            <p>AWS (EKS, EC2, Fargate, Cloudwatch, Lambda, S3 ...)</p>
            <p>Azure</p>
            <p>LXC, LXD, Qemu, OpenShift, Vagrant, VirtualBox</p>
            <p>Linux, Windows Server, MacOS, Android, Gentoo Linux</p>
            <br />

            <h1>Messaging</h1>
            <p>Kafka, AVRO Schema, AKHQ</p>
            <p>MQTT, HiveMQ, Mosquitto</p>
            <p>ActiveMQ, JMS</p>
            <br />

            <h1>Metrics & Logging</h1>
            <p>Prometheus, Telegraf, Grafana</p>
            <p>Loki, Alloy, Logstash, Kibana, Elastic-Stack, Syslog-ng</p>
            <br />

            <h1>Security</h1>
            <p>OAuth2, OIDC, Okta, Keycloak</p>
            <p>Trivy, Renovate, Dependabot</p>
            <p>SSL, Certificates, LetsEncrypt, ACME, Dehydrated</p>
            <p>Security Audits and Pentest Support</p>
            <br />

            <h1>Development Tools</h1>
            <p>Azure DevOps, Jira, Confluence</p>
            <p>Jenkins, Nexus, SonarQube, Bicep, Github Actions, Azure Pipelines</p>
            <p>Git, Bitbucket, Subversion, CVS, TFS, pre-commit hooks</p>
            <p>Cursor IDE, IntelliJ, Eclipse, Visual Studio Code, PyCharm, Postman, Vim</p>
            <p>Agile, Scrum, Kanban, Waterfall</p>
        </div>
    )
}
